module.exports = __webpack_public_path__ + "img/happy-logo-web.dd9e755.png";